import { TFilterPreferencesConfig } from '@/shared/features/filter-preferences/context/filter-preferences-config-context.types';

// Backoffice has no tenant-level preferences: the user layer is the only layer.
export const backofficeFilterPreferencesConfig: TFilterPreferencesConfig = {
  useCompanyDefaults: () => ({ isReady: true }),
  useCompanyWriter: () => null,
};
